import Typeahead from './typeahead'

export const bind = () => {
  new Typeahead('js-ontology-light-typeahead')
}
$(() => bind())
